import React from "react";
import { BsChevronRight, BsBuildings } from "react-icons/bs";
import { Link } from "react-router-dom";

export default function Member({ member }: any) {
  return (
    <Link
      to={`/members/${member?._id}`}
      className="border mb-1 bg-white flex text-sm cursor-pointer hover:bg-gray-50"
    >
      <div className="flex justify-between items-center p-2 w-full">
        <div className="flex items-center">
          <div className="h-20 w-20 rounded-md bg-gray-200 flex justify-center items-center">
            <BsBuildings size={35} />
          </div>
          <div className="flex flex-col ml-4">
            <div className="font-bold text-lg uppercase">{member?.name}</div>
            <div className="text-gray-600">Email: {member?.email}</div>
            <div className="text-gray-600">Mobile: {member?.mobile}</div>
            <div className="text-gray-600 capitalize font-bold">
              {member?.segment}
            </div>
          </div>
        </div>
        <div className="flex justify-center items-center text-xs">
          <span className="mr-2">View All</span>
          <BsChevronRight />
        </div>
      </div>
    </Link>
  );
}
